module.exports = "/assets/b79b2ad88261df1f7e2642e3b594c40b.png";